import React, { useEffect, useState } from "react";
import { Form, Container } from "react-bootstrap";
import {
  faCamera,
  faFileVideo,
  faCloudUploadAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Common_white_header from "../../Common/Common_Component/Common_white_header/Common_white_header";
import Successfull_strip_modal from "../../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";
import "./Deposit_Not_Received_Form.css";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { GetSingle, } from "../../../features/wallet/slice";
import { decodeId } from "../../../utils/common";
import { useForm } from "react-hook-form";
import { SubmitDepositQuery } from "../../../features/support/slice";

function Deposit_Not_Received_Form() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [orderData, setOrderData] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const [files, setFiles] = useState({
    receipt_pdf: null,
    day_1: null,
    day_3: null,
  });
  const [previews, setPreviews] = useState({
    receipt_pdf: null,
    day_1: null,
    day_3: null,
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      utr_number: "",
      receiver_upi_id: "",
      pdf_password: "",
    },
  });

  const fetchOrderData = async (id) => {
    const res = await dispatch(
      GetSingle({ id: decodeId(id), type: "deposite" })
    );
    if (res?.payload?.success) {
      setOrderData(res?.payload?.data);
    }
  };

  useEffect(() => {
    if (id) fetchOrderData(id);
  }, [id]);

  const handleFileChange = (e, key) => {
    const file = e.target.files[0];
    if (!file) return;

    setFiles((prev) => ({ ...prev, [key]: file }));
    setPreviews((prev) => ({
      ...prev,
      [key]: file.type.startsWith("image")
        ? URL.createObjectURL(file)
        : "file_uploaded",
    }));
  };

  const UploadBox = ({ fieldId, isVideo = false, isUpload = false }) => (
    <div className="upload_box">
      <input
        type="file"
        id={fieldId}
        hidden
        accept={
          isVideo ? "video/*" :
            isUpload ? ".pdf,.doc,.docx" :
              "image/*"
        }
        onChange={(e) => handleFileChange(e, fieldId)}
      />
      <label htmlFor={fieldId} className="photo_label">
        {previews[fieldId] && previews[fieldId] !== "file_uploaded" ? (
          <img
            src={previews[fieldId]}
            alt="Preview"
            className="uploaded_img_preview"
          />
        ) : previews[fieldId] === "file_uploaded" ? (
          <div className="success_upload">
            <FontAwesomeIcon
              icon={faCloudUploadAlt}
              style={{ color: "#28a745" }}
            />
            <span>Uploaded</span>
          </div>
        ) : (
          <>
            <FontAwesomeIcon
              icon={
                isVideo ? faFileVideo :
                  isUpload ? faCloudUploadAlt :
                    faCamera
              }
            />
            <span>{isVideo || isUpload ? "Upload" : "Photo"}</span>
          </>
        )}
      </label>
    </div>
  );

  const onSubmit = async (data) => {
    try {
      if (!files.receipt_pdf) {
        setModalMessage("Please upload deposit proof receipt");
        setModalShow(true);
        setTimeout(() => setModalShow(false), 3000);
        return;
      }

      const formData = new FormData();
      formData.append("utr_number", data.utr_number);
      formData.append("receiver_upi_id", data.receiver_upi_id);
      formData.append("pdf_password", data.pdf_password || "");
      formData.append("order_id", orderData?.id || "");

      if (files.receipt_pdf) formData.append("receipt_pdf", files.receipt_pdf);
      if (files.day_1) formData.append("day_1", files.day_1);
      if (files.day_3) formData.append("day_3", files.day_3);

      const res = await dispatch(SubmitDepositQuery(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        setModalMessage("Deposit query submitted successfully");
        setModalShow(true);
        setTimeout(() => {
          setModalShow(false);
          navigate(-1);
        }, 2000);
      } else {
        setModalMessage(res?.payload?.errors || "Submission failed. Please try again");
        setModalShow(true);
        setTimeout(() => setModalShow(false), 3000);
      }

    } catch (error) {
      console.error("Deposit Query Submit Error:", error);
    }
  };

  return (
    <>
      <section className="Modify_Bank_Information Deposit_Not_Received_Form">
        <Common_white_header headingText={"Deposit Not Received"} />
        <Container>
          <Form onSubmit={handleSubmit(onSubmit)} noValidate>

            <Form.Group className="form-group field_holder">
              <Form.Label>
                UTR Number <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Please enter UTR number"
                {...register("utr_number", {
                  required: "UTR number is required",
                  minLength: { value: 12, message: "Minimum 12 characters required" },
                })}
              />
              {errors.utr_number && (
                <small className="text-danger">{errors.utr_number.message}</small>
              )}
            </Form.Group>

            <Form.Group className="form-group field_holder">
              <Form.Label>
                Receiver UPI ID <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Please enter Receiver UPI ID"
                {...register("receiver_upi_id", {
                  required: "Receiver UPI ID is required",
                })}
              />
              {errors.receiver_upi_id && (
                <small className="text-danger">{errors.receiver_upi_id.message}</small>
              )}
            </Form.Group>

            <Form.Group className="form-group field_holder">
              <Form.Label>
                Order Number <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                disabled
                value={orderData?.order_no || ""}
              />
            </Form.Group>

            <Form.Group className="form-group field_holder">
              <Form.Label>
                Amount <span className="mandatory_estrics">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                disabled
                value={orderData?.amount || ""}
              />
            </Form.Group>

            <Form.Group className="form-group field_holder">
              <Form.Label>Provide PDF Password</Form.Label>
              <Form.Control
                type="text"
                placeholder="Provide PDF Password (if any)"
                {...register("pdf_password")}
              />
            </Form.Group>

            <Form.Group className="form-group field_holder">
              <Form.Label>
                Deposit Proof Receipt Detail{" "}
                <span className="mandatory_estrics">*</span>
              </Form.Label>
              <UploadBox fieldId="receipt_pdf" />
              {!files.receipt_pdf && isSubmitting && (
                <small className="text-danger">Please upload deposit proof receipt</small>
              )}
            </Form.Group>

            <div className="note_div">
              <p className="main_note_text">Image Upload Guidelines</p>
              <p className="sub_text">
                Please ensure the uploaded image clearly shows the UTR/UPI number.
              </p>
              <p className="sub_text">
                Uploading unrelated or inappropriate images may lead to failed deposit verification.
              </p>
              <p className="sub_text">
                Repeated violations may result in a temporary or permanent restriction from submitting support tickets.
              </p>
            </div>

            <Form.Group className="form-group field_holder">
              <Form.Label>
                More than 1 Day — Attach video statement using 2 different devices
              </Form.Label>
              <UploadBox fieldId="day_1" isVideo={true} />
            </Form.Group>

            <Form.Group className="form-group field_holder">
              <Form.Label>More than 3 Days — Attach PDF</Form.Label>
              <UploadBox fieldId="day_3" isUpload={true} />
            </Form.Group>

            {/* ── Submit Button ── */}
            <button
              type="submit"
              className="btn_register_bg"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Confirm"}
            </button>

          </Form>
        </Container>
      </section>

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </>
  );
}

export default Deposit_Not_Received_Form;